interface GenericErrorLike {
  message?: unknown;
  name?: unknown;
  stack?: unknown;
  code?: unknown;
}

export function extractErrorInfo(error: unknown) {
  let errorMessage = String(error);
  let errorName: string | undefined;
  let errorStack: string | undefined;
  let errorCode: string | number | undefined;
  if (typeof error === 'object' && error !== null) {
    const errObj = error as GenericErrorLike;
    if (typeof errObj.message === 'string') errorMessage = errObj.message;
    if (typeof errObj.name === 'string') errorName = errObj.name;
    if (typeof errObj.stack === 'string') {
      errorStack = errObj.stack.split('\n').slice(0, 5).join('\n');
    }
    if (
      typeof errObj.code === 'string' ||
      (typeof errObj.code === 'number' && Number.isFinite(errObj.code))
    ) {
      errorCode = errObj.code as string | number;
    }
  }
  return { errorMessage, errorName, errorStack, errorCode };
}

/**
 * True for errors signalling a caller-aborted fetch/async operation. Covers
 * both the DOMException path (browsers + modern Node) and the plain-Error
 * shape some runtimes/libraries still throw, where only `name === 'AbortError'`
 * is reliable.
 */
export function isAbortError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === 'AbortError') return true;
  return (
    typeof error === 'object' &&
    error !== null &&
    (error as { name?: unknown }).name === 'AbortError'
  );
}

export function extractFileInfo(file: File | null | undefined) {
  if (!file) {
    return { fileName: undefined, sizeBytes: undefined, mimeType: undefined };
  }
  return { fileName: file.name, sizeBytes: file.size, mimeType: file.type };
}
